/* ============================================================
   GLOWSKIN — gs-bundle v2 (06/07)
   1) Ameliorations du bloc Quantity discount (teintes, prix,
      ligne cadeau VISUELLE partout — l'ajout reel = gift-sync)
   2) GIFT-SYNC : ajout/retrait/remplacement automatique des
      cadeaux selon la config metafield boutique custom.gs_bundles
      (injectee par theme.liquid dans #gs-bundles-config).
      => AUCUN produit code en dur : nouvelle offre = editer le
      metafield dans l'admin, ce fichier ne change jamais.
   ============================================================ */

/* ------------------ 1. UI bloc bundle ------------------ */
(function () {
  var SHADES = { '01':'#F0D9C0','02':'#E8C6A6','03':'#D9A97A','04':'#B9825A','05':'#8A5A3C' };
  function colorFor(txt){ var m=(txt||'').match(/\d{1,2}/); var k=m?('0'+m[0]).slice(-2):null; return (k&&SHADES[k])||'#E8C6A6'; }
  var CHEV = '<svg class="gs-teinte__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

  var CSS = [
    '.quantity-breaks .quantity-break__variant-picker-container{flex-direction:row!important;flex-wrap:wrap;gap:10px;}',
    '.quantity-breaks .quantity-break__variant-picker-row{flex:1 1 0;min-width:0;align-items:center;}',
    '@media (max-width:749px){.quantity-breaks .quantity-break__variant-picker-row{flex:1 1 calc(50% - 5px);}}',
    '.quantity-breaks .quantity-break__variant-picker-row .select-wrapper{display:none!important;}',
    '.quantity-breaks .quantity-break__variant-thumbnail{display:none!important;}',
    '.gs-teinte{position:relative;flex:1 1 0;min-width:0;}',
    '.gs-teinte__btn{display:flex;align-items:center;gap:10px;width:100%;padding:12px 12px;border:1.5px solid var(--color-input-border,#E3E0DB);border-radius:12px;background:var(--color-input-background,#fff);cursor:pointer;font:inherit;color:inherit;line-height:1;}',
    '.gs-teinte__dot{width:16px;height:16px;border-radius:50%;border:1px solid rgba(0,0,0,.16);flex:0 0 auto;}',
    '.gs-teinte__label{flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;font-size:14px;}',
    '.gs-teinte__chev{flex:0 0 auto;opacity:.55;transition:transform .15s ease;}',
    '.gs-teinte.gs-open .gs-teinte__chev{transform:rotate(180deg);}',
    '.gs-teinte__menu{position:absolute;z-index:30;left:0;right:0;top:calc(100% + 6px);margin:0;padding:6px;list-style:none;background:var(--color-input-background,#fff);border:1.5px solid var(--color-input-border,#E3E0DB);border-radius:12px;box-shadow:0 14px 34px -12px rgba(0,0,0,.28);max-height:250px;overflow:auto;}',
    '.gs-teinte__menu[hidden]{display:none;}',
    '.gs-teinte__opt{display:flex;align-items:center;gap:10px;padding:10px 10px;border-radius:8px;cursor:pointer;font-size:14px;}',
    '.gs-teinte__opt:hover{background:rgba(0,0,0,.05);}',
    '.gs-teinte__opt[aria-selected="true"]{background:rgba(0,0,0,.06);font-weight:600;}',
    '.gs-teinte__opt[aria-disabled="true"]{opacity:.4;cursor:not-allowed;}',
    '.quantity-breaks-container--row .quantity-break__price-and-title-container{position:relative;width:100%;padding-right:135px;}',
    '.quantity-breaks-container--row .quantity-break__price-container{position:absolute;top:50%;right:0;transform:translateY(-50%);margin:0;}',
    '.quantity-breaks-container--row .quantity-break__price-container .prices,.quantity-breaks-container--row .quantity-break__price-container .price-container{justify-content:flex-end;}',
    '.quantity-breaks .quantity-break__cross-sell .checkbox,.quantity-breaks .quantity-break__cross-sell .radio,.quantity-breaks .quantity-break__cross-sell .checkmark,.quantity-breaks .quantity-break__cross-sell input{display:none!important;}',
    '.quantity-breaks .quantity-break__cross-sell-info{justify-content:flex-start!important;gap:8px;}',
    '.quantity-breaks .quantity-break__cross-sell-price{margin-left:auto;}',
    '.quantity-breaks .quantity-break__cross-sell-price s{opacity:.55;}',
    '.quantity-breaks .gs-offert{flex:0 0 auto;}'
  ].join('');

  function injectCSS(){ if(document.getElementById('gs-bundle-css')) return; var s=document.createElement('style'); s.id='gs-bundle-css'; s.textContent=CSS; document.head.appendChild(s); }

  function closeAll(){ document.querySelectorAll('.gs-teinte.gs-open').forEach(function(w){ w.classList.remove('gs-open'); var m=w.querySelector('.gs-teinte__menu'); if(m) m.hidden=true; }); }

  function sync(sel){
    var wrap=sel._gsWrap; if(!wrap) return;
    var opt=sel.options[sel.selectedIndex];
    wrap.querySelector('.gs-teinte__btn .gs-teinte__dot').style.background=colorFor(opt&&opt.text);
    wrap.querySelector('.gs-teinte__label').textContent=opt?opt.text:'';
    wrap.querySelectorAll('.gs-teinte__opt').forEach(function(li){ li.setAttribute('aria-selected', li.dataset.value===sel.value?'true':'false'); });
  }

  function buildDropdown(sel){
    if(sel.dataset.gsDone){ sync(sel); return; }
    var row=sel.closest('.quantity-break__variant-picker-row'); if(!row) return;
    sel.dataset.gsDone='1';
    var wrap=document.createElement('div'); wrap.className='gs-teinte';
    var btn=document.createElement('button'); btn.type='button'; btn.className='gs-teinte__btn';
    btn.innerHTML='<span class="gs-teinte__dot"></span><span class="gs-teinte__label"></span>'+CHEV;
    var menu=document.createElement('ul'); menu.className='gs-teinte__menu'; menu.hidden=true;
    Array.prototype.forEach.call(sel.options, function(opt){
      var li=document.createElement('li'); li.className='gs-teinte__opt'; li.dataset.value=opt.value;
      if(opt.disabled) li.setAttribute('aria-disabled','true');
      li.innerHTML='<span class="gs-teinte__dot" style="background:'+colorFor(opt.text)+'"></span><span>'+opt.text+'</span>';
      li.addEventListener('click', function(e){ e.stopPropagation(); if(opt.disabled) return; sel.value=opt.value; sel.dispatchEvent(new Event('change',{bubbles:true})); sync(sel); wrap.classList.remove('gs-open'); menu.hidden=true; });
      menu.appendChild(li);
    });
    btn.addEventListener('click', function(e){ e.stopPropagation(); var willOpen=menu.hidden; closeAll(); menu.hidden=!willOpen; wrap.classList.toggle('gs-open', willOpen); });
    wrap.appendChild(btn); wrap.appendChild(menu); row.appendChild(wrap);
    sel._gsWrap=wrap; sync(sel);
  }

  function decorate(root){
    root.querySelectorAll('[data-ref="quantity-break-variant-picker"]').forEach(buildDropdown);
    // cadeau : ligne VISUELLE partout — l'ajout reel est fait par le gift-sync
    root.querySelectorAll('[data-ref="quantity-break-cross-sell-checkbox"]').forEach(function(cb){
      if(cb.checked){ cb.checked=false; cb.dispatchEvent(new Event('change',{bubbles:true})); }
      cb.disabled=true;
    });
  }

  function observe(root){
    if(root._gsObs) return;
    var obs=new MutationObserver(function(){ if(root._gsT) return; root._gsT=setTimeout(function(){ root._gsT=null; decorate(root); }, 60); });
    obs.observe(root, { childList:true, subtree:true });
    root._gsObs=obs;
  }

  function boot(){
    var roots=document.querySelectorAll('quantity-breaks'); if(!roots.length) return;
    injectCSS();
    roots.forEach(function(root){ decorate(root); observe(root); root.addEventListener('click', function(){ setTimeout(function(){ decorate(root); }, 30); }); });
  }

  document.addEventListener('click', closeAll);
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 80); });
  if(document.readyState!=='loading') setTimeout(boot,120);
  else document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,120); });
})();

/* ------------------ 2. GIFT-SYNC (config-driven) ------------------ */
(function () {
  function config(){
    try{
      var el=document.getElementById('gs-bundles-config');
      var cfg=el?JSON.parse(el.textContent):null;
      return (cfg && Array.isArray(cfg.bundles)) ? cfg.bundles : [];
    }catch(e){ return []; }
  }

  function refreshCart(){
    var els=[document.querySelector('cart-drawer'), document.querySelector('cart-icon')];
    var ids=[];
    els.forEach(function(el){ var s=el&&el.closest('[id^="shopify-section-"]'); if(s) ids.push(s.id.replace('shopify-section-','')); });
    if(!ids.length) return Promise.resolve();
    return fetch('/?sections='+encodeURIComponent(ids.join(','))).then(function(r){return r.json();}).then(function(data){
      if(!data) return;
      ids.forEach(function(id){
        var html=data[id]; if(!html) return;
        var frag=new DOMParser().parseFromString(html,'text/html');
        var ni=frag.querySelector('.cart-drawer__inner'), ci=document.querySelector('.cart-drawer__inner');
        if(ni&&ci){ ci.replaceWith(ni); }
        var nIcon=frag.querySelector('cart-icon'), cIcon=document.querySelector('cart-icon');
        if(nIcon&&cIcon){ cIcon.replaceWith(nIcon); }
      });
    }).catch(function(){});
  }

  // Plan d'actions (v2.2) : le cadeau est le VRAI produit payant, sur une ligne
  // dediee marquee par la propriete _gs_gift. La Function n'offre qu'UNE unite
  // de cette ligne -> si le client fait +1 dessus, les unites suivantes sont
  // payantes. Resolution GLOBALE : on calcule l'ensemble des cadeaux desires
  // (tous bundles confondus), puis :
  //  - ligne _gs_gift desiree      -> conservee telle quelle (qty libre)
  //  - ligne _gs_gift plus desiree -> supprimee ; ses unites au-dela de la
  //    1re (payees par le client) sont re-ajoutees en ligne NORMALE
  //  - cadeau desire absent        -> ajoute (qty 1, propriete _gs_gift)
  function plan(cart){
    var bundles=config();
    var desired={};
    bundles.forEach(function(b){
      if(!b || !b.handle || !Array.isArray(b.gifts) || !b.gifts.length) return;
      var qty=0;
      cart.items.forEach(function(it){ if(it.handle===b.handle) qty+=it.quantity; });
      var target=null;
      b.gifts.forEach(function(g){ if(qty>=g.min_qty && (!target || g.min_qty>target.min_qty)) target=g; });
      if(target) desired[target.variant_id]=true;
    });
    var giftVariants={};
    bundles.forEach(function(b){ (b.gifts||[]).forEach(function(g){ giftVariants[g.variant_id]=true; }); });

    var toRemove=[], toAdd=[], toAddPlain=[];
    var present={};
    cart.items.forEach(function(it){
      var isGiftLine = it.properties && it.properties._gs_gift && giftVariants[it.variant_id];
      if(!isGiftLine) return;
      if(desired[it.variant_id]){
        present[it.variant_id]=true;                    // on n'y touche pas (qty libre)
      } else {
        toRemove.push({key:it.key, qty:0});             // retire la ligne cadeau
        if(it.quantity>1) toAddPlain.push({id:it.variant_id, quantity:it.quantity-1}); // reconvertit les unites payees
      }
    });
    Object.keys(desired).forEach(function(v){ if(!present[v]) toAdd.push(Number(v)); });
    return { toRemove:toRemove, toAdd:toAdd, toAddPlain:toAddPlain };
  }

  function readCart(){ return fetch('/cart.js').then(function(r){return r.json();}); }

  function apply(p){
    var chain=Promise.resolve();
    p.toRemove.forEach(function(r){
      chain=chain.then(function(){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:r.key,quantity:r.qty})}); });
    });
    var items=p.toAdd.map(function(v){ return {id:v, quantity:1, properties:{_gs_gift:"1"}}; })
      .concat(p.toAddPlain||[]);
    if(items.length){
      chain=chain.then(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}); });
    }
    return chain;
  }

  var running=false, attempts=0;
  function enforce(){
    if(running) return; running=true;
    return readCart().then(function(cart){
      var p=plan(cart);
      if(!p.toRemove.length && !p.toAdd.length && !(p.toAddPlain&&p.toAddPlain.length)){ running=false; attempts=0; return; }
      // Ajout seul : immediat (aucun risque). Retrait : double-verif 600ms
      // (ne pas supprimer pendant les ajouts multi-lignes du bundle).
      var delay = p.toRemove.length ? 600 : 0;
      return new Promise(function(res){ setTimeout(res,delay); }).then(readCart).then(function(cart2){
        var p2=plan(cart2);
        if(!p2.toRemove.length && !p2.toAdd.length && !(p2.toAddPlain&&p2.toAddPlain.length)){ running=false; attempts=0; return; }
        if(attempts>=3){ running=false; return; } // garde-fou (ex. cadeau en rupture)
        attempts++;
        return apply(p2).then(refreshCart).then(function(){ running=false; enforce(); });
      });
    }).catch(function(){ running=false; });
  }

  var _f=window.fetch;
  window.fetch=function(){
    var a=arguments[0]; var url=(a&&a.url)?a.url:a;
    var p=_f.apply(this,arguments);
    if(typeof url==='string' && /\/cart\/(add|change|update)(\.js)?/.test(url)){ p.then(function(){ setTimeout(enforce,60); }); }
    return p;
  };
  if(document.readyState!=='loading') enforce();
  else document.addEventListener('DOMContentLoaded', enforce);
})();
